import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import React, { Suspense } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { WorkspaceProvider } from './hooks/useWorkspace';
import Layout from './components/Layout';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { user, loading } = useAuth();
    if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
    if (!user) return <Navigate to="/login" />;
    return <>{children}</>;
};

// Lazy load pages for better performance
const Landing = React.lazy(() => import('./pages/Landing'));
const Login = React.lazy(() => import('./pages/Login'));
const Onboarding = React.lazy(() => import('./pages/Onboarding'));
const Connections = React.lazy(() => import('./pages/Connections'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const TrendExplorer = React.lazy(() => import('./pages/TrendExplorer'));
const CreativeHub = React.lazy(() => import('./pages/CreativeHub'));
const Forecasting = React.lazy(() => import('./pages/Forecasting'));
const Reports = React.lazy(() => import('./pages/Reports'));
const Settings = React.lazy(() => import('./pages/Settings'));
const Portfolio = React.lazy(() => import('./pages/Portfolio'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));


function App() {
    return (
        <AuthProvider>
            <WorkspaceProvider>
                <Router>
                    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/privacy" element={<PrivacyPolicy />} />

                            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                            <Route path="/connections" element={<ProtectedRoute><Layout><Connections /></Layout></ProtectedRoute>} />
                            <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
                            <Route path="/trends" element={<ProtectedRoute><Layout><TrendExplorer /></Layout></ProtectedRoute>} />
                            <Route path="/creatives" element={<ProtectedRoute><Layout><CreativeHub /></Layout></ProtectedRoute>} />
                            <Route path="/forecasting" element={<ProtectedRoute><Layout><Forecasting /></Layout></ProtectedRoute>} />
                            <Route path="/portfolio" element={<ProtectedRoute><Layout><Portfolio /></Layout></ProtectedRoute>} />
                            <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
                            <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
                        </Routes>
                    </Suspense>
                </Router>
            </WorkspaceProvider>
        </AuthProvider>
    );
}

export default App;
